import { Grid } from "@material-ui/core";
import DateRange from "components/DateRange";
import { DefaultRangesTypes } from "components/DateRange/DefaultRanges";
import DropdownFilter from "components/DropdownFilter";
import { dateFilterTypes, dateFilterTypesListWithCustom, getDateFilterRanges } from "features/loads/components/LoadsDashboard/loadsDashboardConsts";
import { useDispatch, useSelector } from "react-redux";
import { NewWashDashboardStyle } from "../NewWashDashboardStyle";
import { setActivityFilters } from "../washDashboardSlice";
import { useEffect } from "react";
import { isEqual } from "lodash";
import { withUserPreferences } from "components/UserPreferences/WithUserPreferences";
import { userPreferencesComponentIds, userPreferencesTypes } from "components/UserPreferences/userPreferencesConsts";

const WashFilters = ({ filterConfigs, activityItems, saveFilters, savedFilters }) => {
    const classes = NewWashDashboardStyle();
    const { activityFilters } = useSelector(state => state.washDashboardState);
    const dispatch = useDispatch();

    const handleFilterChange = (key, value) => {
        const newFilters = { ...activityFilters, [key]: { value: value } };
        dispatch(setActivityFilters(newFilters));
        saveFilters(newFilters);
    }

    const dateFilterRanges = getDateFilterRanges({ weekCount: 7, yearCount: 3 });

    const onChangeDateFilter = (val, filterType = null) => {
        let item = dateFilterRanges?.[filterType ?? activityFilters?.['dateFilterType']?.value]?.find(f => f.id == +val);
        if (item) {
            const newFilters = {
                ...activityFilters,
                ['dateFilter']: { value: val },
                ['dateFilterType']: { value: filterType ?? activityFilters?.['dateFilterType']?.value },
                ['startDate']: { value: item.startDate?.toDateString() },
                ['endDate']: { value: item.endDate?.toDateString() }
            };
            dispatch(setActivityFilters(newFilters));
            saveFilters(newFilters);
        }
    }

    const onChangeDateRange = (val) => {
        const startDate = val?.startDate;
        const endDate = val?.endDate;

        const newFilters = {
            ...activityFilters,
            ['startDate']: { value: startDate?.toDateString() ?? null },
            ['endDate']: { value: endDate?.toDateString() ?? null }
        };
        dispatch(setActivityFilters(newFilters));
        saveFilters(newFilters);
    }

    const onChangeDateFilterType = (val) => {
        onChangeDateFilter(1, val);
    }

    useEffect(() => {
        if (savedFilters)
        {
            const mapped = { ...activityFilters };
            Object.entries(savedFilters).forEach(([k, v]) => {
                mapped[k] = { value: (v && typeof v === 'object' && Object.prototype.hasOwnProperty.call(v, 'value')) ? v.value : v ?? null};
            });
            if (!isEqual(mapped, activityFilters)) {
                dispatch(setActivityFilters(mapped));
            }
        }
    }, [savedFilters]); 

    return (
        <Grid container spacing={1} alignItems="center" justifyContent="space-between">
            <Grid item xs={12} className={classes.filtersWrapper}>
                <Grid item xs={3}
                    className={classes.filterItem}
                >
                    <DropdownFilter
                        showEmpty
                        title={'Activity'}
                        values={activityItems?.map(item => ({ id: item.id, name: item.name })) || []}
                        onSelect={(val) => {
                            handleFilterChange('activityItemId', +val);
                        }}
                        value={activityFilters?.['activityItemId']?.value}
                        className={classes.selectWhite}
                        shrink
                    />

                </Grid>
                <Grid item xs={3}
                    className={classes.filterItem}
                >
                    <DropdownFilter
                        showEmpty
                        title={'Auto Generated'}
                        values={[
                            { id: 'all', name: 'All Washes' },
                            { id: 'true', name: 'Auto Generated' },
                            { id: 'false', name: 'Manual' }
                        ]}
                        onSelect={(val) => {
                            handleFilterChange('autoGenerated', val);
                        }}
                        value={activityFilters?.['autoGenerated']?.value}
                        className={classes.selectWhite}
                        shrink
                    />
                </Grid>
                <Grid item xs={3}
                    className={classes.filterItem}
                >
                    <DropdownFilter
                        showEmpty
                        title={'Filter Date by'}
                        values={dateFilterTypesListWithCustom}
                        onSelect={(val) => {
                            onChangeDateFilterType(val);
                        }}
                        value={activityFilters?.['dateFilterType']?.value}
                        className={classes.selectWhite}
                        shrink
                    />
                </Grid>
                <Grid item xs={3}
                    className={classes.filterItemLast}
                >
                    {activityFilters?.['dateFilterType']?.value != dateFilterTypes.CUSTOM ? <DropdownFilter
                        showEmpty
                        title={'Specific Date'}
                        values={dateFilterRanges?.[activityFilters?.['dateFilterType']?.value]}
                        onSelect={(val) => {
                            onChangeDateFilter(val);
                        }}
                        value={activityFilters?.['dateFilter']?.value}
                        className={classes.selectWhite}
                        shrink
                    /> : <DateRange
                        title='Date Range'
                        inputClassName={classes.dateRange}
                        onSelect={onChangeDateRange}
                        dateValue={{ startDate: activityFilters?.['startDate']?.value ? new Date(activityFilters?.['startDate']?.value) : null, endDate: activityFilters?.['endDate']?.value ? new Date(activityFilters?.['endDate']?.value) : null }}
                        filterButton
                        withClearButton={false}
                        showPredefinedRanges
                        useRanges={[DefaultRangesTypes.LAST_WEEK, DefaultRangesTypes.LAST_MONTH, DefaultRangesTypes.LAST_SIX_WEEKS, DefaultRangesTypes.LAST_YEAR]}
                        shrink
                    />}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default withUserPreferences(WashFilters, userPreferencesComponentIds.WASH_DASHBOARD_ACTIVITY_FILTERS, userPreferencesTypes.FILTERS);